/**
 * File: medicalFeatureList.js
 * Project: educore
 * Created Date: 2019-03-12
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class MedicalFeatureController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state) {
        this.$onInit = () => {
                $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
                if (!$rootScope.isLoggedIn) {
                    $state.go("login", {}, {
                        reload: true
                    })
                }
            }
        //To get Roles and Privileges
        let medicalUserAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "medicalFeatureList"
        })
        let medicalUserPrivilege = {};
        if (medicalUserAccess.length > 0) {
            _.each(medicalUserAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                medicalUserPrivilege[tpObj.feature_id] = user_access;
            })
        }
        let featuresList = [{
            "_id": "userProfile",
            "name": "User Profile",
            "state": "userFilter",
            "icon": "../../../img/medical/incidents.png",
            "color": "#f16e02"
        }, {
            "_id": "programme",
            "name": "Programme",
            "state": "viewProgramme",
            "icon": "../../../img/medical/medical.png",
            "color": "#00b4bd"
        }, {
            "_id": "inventory",
            "name": "Inventory",
            "state": "inventoryList",
            "icon": "../../../img/medical/medical.png",
            "color": "#f35966"

        }, {
            "_id": "purchase",
            "name": "Purchase",
            "state": "purchaseList",
            "icon": "../../../img/medical/medical.png",
            "color": "#00ba9c"
        }, {
            "_id": "programmeConsole",
            "name": "Programme Console",
            "state": "programmeConsole",
            "icon": "../../../img/medical/medical.png",
            "color": "#00b4bd"
        }, {
            "_id": "medicalDashboard",
            "name": "Medical Dashboard",
            "state": "medicalProfile",
            "icon": "../../../img/medical/medical_dashboard.png",
            "color": "#f35966"
        }, {
            "_id": "childMedicalProfile",
            "name": "Child Medical Profile",
            "state": "childProfile",
            "icon": "../../../img/medical/child_view.png",
            "color": "#f16e02"
        }, {
            "_id": "createImmunization",
            "name": "Create Immunization",
            "state": "createImmunization",
            "icon": "../../../img/medical/medical_questions.png",
            "color": "#00ba9c"
        }];

        if (medicalUserPrivilege != undefined) {
            $scope.featuresList = []
            _.each(medicalUserPrivilege, function(obj, key) {
                let feature = _.find(featuresList, function(featureObj) {
                    return featureObj._id === key
                })
                if (feature)
                    $scope.featuresList.push(feature)

            })
        }

        /*
         * To navigate to selected page
         * 
         * @feature : Object - Selected feature detail
         * 
         * @return : null
         *
         * 
         */
        $scope.navigatePage = function(feature) {
            console.log(feature)
            $state.go(feature.state, {}, {
                reload: true
            })
        }

        this.$onDestroy = () => {

        }
    }
}

export default MedicalFeatureController;



// WEBPACK FOOTER //
// ./src/app/medical/controllers/medicalFeatureList.js